// ================ Action types ================ //

export const LOCATION_CHANGED = 'app/Routing/LOCATION_CHANGED';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.Routing} */
const initialState = {
  currentLocation: null,
  currentCanonicalUrl: null,
  previousLocation: undefined,
};

export default function routingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CHANGED:
      return {
        ...state,
        currentLocation: payload.location,
        currentCanonicalUrl: payload.canonicalUrl,
        previousLocation:
          state.currentLocation?.pathname || (typeof window !== 'undefined' && document.referrer),
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const locationChanged = (location, canonicalUrl, routeName) => ({
  type: LOCATION_CHANGED,
  payload: { location, canonicalUrl, routeName },
});
